import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  InputBase,
  InputLabel,
  MenuItem,
  withStyles,
} from '@material-ui/core';
import { Label, Error, Required, Option, NativeSelect } from './style';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 0,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    fontSize: 16,
    padding: '12px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 0,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

const CusSelect = ({
  label,
  name,
  value,
  options,
  placeholder,
  error,
  onChange,
  isRequired,
  borderRadius,
  height,
  disabled,
}) => {
  return (
    <Grid direction='column' alignItems='flex-start' container item>
      {label && (
        <Label>
          {label} {isRequired && <Required>*</Required>}
        </Label>
      )}
      <NativeSelect
        name={name}
        value={value}
        onChange={onChange}
        input={<BootstrapInput />}
        borderRadius={borderRadius}
        height={height}
        disabled={disabled}
      >
        {placeholder && (
          <MenuItem value=''>
            <em>{placeholder}</em>
          </MenuItem>
        )}
        {options.map((op) => (
          <MenuItem key={`lh-${op.key}`} value={op.key}>
            {op.value}
          </MenuItem>
        ))}
      </NativeSelect>
      {error && <Error>{error}</Error>}
    </Grid>
  );
};

CusSelect.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  isRequired: PropTypes.bool,
};

CusSelect.defaultProps = {
  value: '',
  disabled: false,
};

export default CusSelect;
